import { createAction } from 'redux-actions'
import {
  GET_RECENT_EXPENSE_RECORDS,
  GET_RECENT_EXPENSE_RECORDS_FAILED,
  GET_RECENT_EXPENSE_RECORDS_SUCCEEDED,
} from 'Redux/Types/RecentExpenseTypes'

export const getRecentExpenses = createAction(GET_RECENT_EXPENSE_RECORDS)
export const getRecentExpensesFailed = createAction(GET_RECENT_EXPENSE_RECORDS_FAILED)
export const getRecentExpensesSucceeded = createAction(GET_RECENT_EXPENSE_RECORDS_SUCCEEDED)
